import type { ColDef, GridApi } from 'ag-grid-community'

import { QRADatasetRow } from '$/types'
import { IColorByValueConfig } from 'app/services/api/colorByValue'
import { cbvCellRendererGenerator } from 'features/DataManagement/Components/Tables/CellRenderer/CBVCellRenderer'

/**
 * NOTE: This appears to be the ideal implementation as we will
 *       need access to grid API to trigger rerender of the cells
 *       everytime to CBV config updates.
 */
const syncCBVConfigToColDefs = (
  gridApi: GridApi<QRADatasetRow>,
  colorByValueConfig?: IColorByValueConfig
) => {
  if (gridApi == null || colorByValueConfig == null) {
    return
  }

  const colDefs = gridApi.getColumnDefs()

  if (colDefs) {
    const colDefMapper = (colDef: ColDef<QRADatasetRow>) => {
      const cbvAttributeMap = colorByValueConfig.attributesMap.find(
        // NOTE: avoid match on ID as data source column currently reuse IDs
        (attr) => attr.attributeCode === colDef.field
      )

      if (cbvAttributeMap) {
        // Cell Renderer Coloring
        const isSelected =
          cbvAttributeMap.attributeId === colorByValueConfig.selectedAttributeId

        return {
          ...colDef,
          cellRenderer: cbvCellRendererGenerator(
            cbvAttributeMap,
            isSelected,
            colDef.cellRenderer
          )
        }
      }

      return colDef
    }

    gridApi.setGridOption('columnDefs', colDefs.map(colDefMapper))
  }
}

export default syncCBVConfigToColDefs
